import { getPropertyById } from "../../../../SOA/api";
import { getInspectionById } from "./Api";

export const defaultInspectionItem = {
  inspectionTypeId: '',
  inspectionTypeName: '',
  frequencyId: '',
  frequencyName: '',
  contractor: '',
  dueDate: '',
  notes: '',
  reminderDays: undefined,
  completed: null,
};

export const defaultInspection = {
  property: {
    propertyId: '',
    buildingName: '',
  },
  year: new Date().getFullYear(),
  inspections: [{ ...defaultInspectionItem }],
};

export const getPropertyDetailsForInspection = async (propertyId) => {
  try {
    if (!propertyId) throw new Error('Property ID is required');
    const property = await getPropertyById(propertyId);
    if (!property) throw new Error('Property not found');
    return { property };
  } catch (error) {
    console.error('Error fetching property details for inspection:', error);
    throw error;
  }
};

export const autoFillPropertyDetails = async (currentFormValues, propertyId, buildingName = '') => {
  try {
    if (!propertyId) {
      return { ...currentFormValues, property: { propertyId: '', buildingName: '' } };
    }
    const { property } = await getPropertyDetailsForInspection(propertyId);
    return {
      ...currentFormValues,
      property: {
        propertyId,
        buildingName: (buildingName || property.title || property.name || '').trim(),
      },
      year: currentFormValues.year || new Date().getFullYear(),
      inspections: currentFormValues.inspections?.length ? currentFormValues.inspections : [{ ...defaultInspectionItem }],
    };
  } catch (error) {
    console.error('Failed to auto-fill property details:', error);
    return currentFormValues;
  }
};

export const getInspectionInitialValues = async (id) => {
  if (!id) return defaultInspection;
  try {
    const inspection = await getInspectionById(id);
    return {
      property: {
        propertyId: inspection.property?.propertyId?._id || inspection.property?.propertyId || '',
        buildingName: inspection.property?.buildingName || '',
      },
      year: inspection.year || new Date().getFullYear(),
      inspections: (inspection.inspections || []).map((item) => ({
        inspectionTypeId: item.inspectionTypeId?._id || item.inspectionTypeId || '',
        inspectionTypeName: item.inspectionTypeName || '',
        frequencyId: item.frequencyId?._id || item.frequencyId || '',
        frequencyName: item.frequencyName || '',
        frequencyDays: item.frequencyDays || undefined,
        contractor: item.contractor || '',
        dueDate: item.dueDate ? new Date(item.dueDate).toISOString().split('T')[0] : '',
        notes: item.notes || '',
        reminderDays: item.reminderDays || undefined,
        completed: item.completed
          ? {
            completedDate: item.completed.completedDate ? new Date(item.completed.completedDate).toISOString().split('T')[0] : '',
            notes: item.completed.notes || '',
            attachments: item.completed.attachments || [],
            contractorInvoice: item.completed.contractorInvoice || '',
          }
          : null,
      })),
    };
  } catch (error) {
    console.error('Failed to fetch inspection record for editing:', error);
    return defaultInspection;
  }
};